import axios from 'axios'
import AuthService from '@/services/AuthService';

const instance = axios.create({
    baseURL: process.env.VUE_APP_MASTERS_API_URL
});

export default {
    getBrands: async function () {
        try {
            const response = await instance.get('brands')
            return response;
        } catch (error) {
            return error.response;
        }
    },
    getBrandsByPagination: async function (query) {
        try {
            const response = await instance.get('brands'+query)
            return response;
        } catch (error) {
            return error.response;
        }
    },
    updateBrand: async function (name, description,id) {
        try {
            const response = await instance.put('brand?id='+id, {
                "name": name,
                "description": description
            },
            {
         headers: {
                    'Authorization': AuthService.getToken()
                  }
            })
            return response;
        } catch (error) {
            return error.response;
        }
    },
   

   createBrand : async function ( name,description) {
    console.log("barnd object",{"name" : name, "description": description });
        try {
            const response = await instance.post('brand', {
                "name" : name,
                "description": description

            },{
                headers: {
                    'Authorization': AuthService.getToken()
                  }
            })
            return response;
        } catch (error) {
            return error.response;
        }
    },

    deleteBrand : async function (id) {
              try {
                console.log("deleted id from controoler",id)
            const response = await instance.delete('admin/meta/brands/'+id,{
                headers: {
                    'Authorization': AuthService.getToken()
                  }
            })
            return response;
        } catch (error) {
            return error.response;
        }
    },
    deleteBulkBrand : async function (ids) {
        try {
          console.log("brands",ids)
      const response = await instance.delete('brands',{
        data:{
            ids:ids
        }
      },{
          headers: {
              'Authorization': AuthService.getToken()
            }
      })
      return response;
  } catch (error) {
      return error.response;
  }
},
    searchBrand: async function (pageSize,page, search) {
    try {
        const response = await instance.get('meta/brands?pageSize='+pageSize+'&page='+page+'&search='+search)
        return response;
    } catch (error) {
        return error.response;
    }
},


}

